import { memo, useEffect } from "react";
import { TextInput, useDataProvider, useResourceContext } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { useMutation } from "react-query";

const GoodsInTransitInput = ({ dependOn, ...props }) => {
  const dataProvider = useDataProvider();
  const tenCode = useWatch({ name: dependOn });
  const resource = useResourceContext();
  const { setValue } = useFormContext();
  // GET NEXT NUMBER
  const { data, mutate } = useMutation((dt) =>
    dataProvider.getListNoParams(resource + "/goods-in-transit?code=" + dt)
  );
  // GET NEXT NUMBER

  useEffect(() => {
    if (tenCode) {
      mutate(tenCode);
    }
  }, [tenCode]);
  useEffect(() => {
    if (data || data === 0) {
      setValue(props.source, data);
    }
  }, [data]);
  return <TextInput {...props} />;
};

const propsAreEqual = (prevProps, nextProps) => {
  if (
    prevProps.source === nextProps.source &&
    prevProps.dependOn === nextProps.dependOn
  ) {
    // tidak perlu render ulang
    return true;
  }
  // perlu dirender ulang
  return false;
};

export default memo(GoodsInTransitInput, propsAreEqual);
